/* eslint-disable react/prop-types */
/* eslint-disable prettier/prettier */
import styled from '@emotion/styled';
import _ from 'lodash';

import Cta from './OC/oc-cta';
import { cmsLegacyThemeConnector } from './PageBuilder/redux/connector';
import wrappedInReduxProvider from './wrappedInReduxProvider';

const StyledCta = cmsLegacyThemeConnector(styled(Cta)`
  left: 15px;
  position: absolute;
  top: -45px;
  transition: all .5s ease;

  &:focus {
    outline: 2px solid ${props => props.legacyTheme.colors.brand};
    text-decoration: underline;
    top: 15px;
  }

  &.fleetwoodusa {
    background-color: #FFFFFF;
    border-color: #FFFFFF;
    color: #000000;

    &:hover {
      border-color: #E6E6E6;
      color: ${props => props.legacyTheme.colors.brand};

      &:before {
        background-color: #E6E6E6;
      }
    }
  }
`);

const SkipToContent = ({ className }) => {
  const classList = _.compact(['skip-to-content', className]);
  const buttonCopy = 'Skip to Main Content';
  return (
    <StyledCta
      className={classList.join(' ')}
      href="#maincontent"
      id="skip-to-content-id"
      text={buttonCopy}
      title={buttonCopy}
    >
      {buttonCopy}
    </StyledCta>
  );
};

export default wrappedInReduxProvider(SkipToContent);
